import { ComponentFactoryResolver, Directive, OnInit, ViewContainerRef } from '@angular/core';
import { FooterComponent } from '@app-shared/components/footers/footer.model';
import { CLIENT_CONFIG } from '@config/config';

@Directive({
  selector: '[appFooterHost]',
})
export class FooterDirective implements OnInit {
  public copyrightyear = new Date().getFullYear();
  public clientConfig = CLIENT_CONFIG;

  constructor(public viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit(): void {
    this.loadFooterComponent();
  }

  private loadFooterComponent() {
    this.viewContainerRef.clear();
    if (this.clientConfig?.landingPageDetails?.footer?.component) {
      const component = this.componentFactoryResolver.resolveComponentFactory<FooterComponent>(
        this.clientConfig.landingPageDetails.footer.component
      );
      const componentRef = this.viewContainerRef.createComponent<FooterComponent>(component);
      componentRef.instance.data = { copyrightyear: this.copyrightyear };
    }
  }
}
